/* eslint-disable react/no-unescaped-entities */
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  Compass, Wrench, Cpu, LineChart, Gauge, Server,
  Stethoscope, Megaphone, MapPin, Handshake, Building2, Car,
} from "lucide-react";
import { MODULES } from "@/lib/content";

const ICONS = { Compass, Wrench, Cpu, LineChart, Gauge, Server, Stethoscope, Megaphone, MapPin, Handshake, Building2, Car };

export default function Modules() {
  return (
    <section className="relative py-16 md:py-24 lg:py-32 bg-[#080808] border-y border-zinc-900" id="modules" data-testid="modules-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#FFD60A]" />
              <span className="font-mono text-xs tracking-[0.4em] text-[#FFD60A] uppercase">Programme</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white uppercase leading-[0.95]">
              Ce que vous allez <span className="text-[#FFD60A]">apprendre</span>
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="text-lg text-zinc-400 leading-relaxed">
              <span className="text-white font-semibold">12 modules</span> conçus avec des reprogrammeurs en activité. Du matériel pro à la facturation, du flash ECU à Google Business : tout ce qu'il vous faut pour devenir rentable.
            </p>
          </div>
        </div>

        <Accordion type="single" collapsible className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-800">
          {MODULES.map((m, i) => {
            const Icon = ICONS[m.icon] || Compass;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
                className="bg-[#0a0a0a]"
              >
                <AccordionItem value={`m-${i}`} className="border-0" data-testid="module-accordion-item">
                  <AccordionTrigger className="px-6 py-6 hover:no-underline hover:bg-[#111] group [&[data-state=open]]:bg-[#111] [&[data-state=open]>div>div:first-child]:border-[#FFD60A] [&[data-state=open]>div>div:first-child]:bg-[#FFD60A]/10">
                    <div className="flex items-center gap-5 text-left w-full">
                      <div className="w-12 h-12 flex items-center justify-center border border-zinc-800 transition-all shrink-0">
                        <Icon size={20} className="text-[#FFD60A]" strokeWidth={1.5} />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-mono text-[10px] text-zinc-500 tracking-widest mb-1">
                          MODULE {m.n}
                        </div>
                        <div className="font-display text-xl md:text-2xl text-white uppercase tracking-wide leading-tight">
                          {m.title}
                        </div>
                      </div>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 pt-0 pl-[5.25rem]">
                    <p className="text-zinc-400 text-sm leading-relaxed">{m.desc}</p>
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
